module.exports = __webpack_public_path__ + "media/images/expand-097df1053ff3246e2f1af9d5a858ac6c.gif";